import styled from "@emotion/styled";
import { fontFredoka } from "@product/scmp-sdk";

import { Button } from "~/components/posties/button";

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  font-family: ${fontFredoka};

  ${props => props.theme.breakpoints.up("tablet")} {
    flex-direction: row;
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    flex-direction: column;
  }
`;

export const TextContainer = styled.div`
  flex: 1;

  text-align: center;

  ${props => props.theme.breakpoints.up("tablet")} {
    text-align: start;
  }
`;

export const Title = styled.div`
  margin-block-end: 8px;

  color: #333333;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  letter-spacing: 0.01em;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 16px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 32px;
    line-height: 32px;
  }
`;

export const Description = styled.div`
  color: #333333;
  font-size: 16px;
  line-height: 22px;
  text-align: start;

  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const ButtonContainer = styled.div`
  margin-block-start: 16px;

  ${props => props.theme.breakpoints.up("desktop")} {
    margin-block-start: 32px;
  }
`;

export const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 144px;

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 156px;
  }
`;

export const ImageContainer = styled.div`
  inline-size: 160px;
  margin-block-end: 16px;

  aspect-ratio: 1/1;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 0;
    margin-inline-end: 24px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    inline-size: 280px;
    margin-block-end: 32px;
    margin-inline-end: 0;
  }

  img {
    max-inline-size: 100%;
  }
`;
